<template>
  <div>
    <div>
      <!-- TITULO / TOOLBAR FILTERS -->
      <div
        class="d-flex"
        :class="{
          'justify-space-between align-center my-4': !$vuetify.breakpoint
            .mobile,
          'flex-column': $vuetify.breakpoint.mobile,
        }"
      >
        <div
          class="d-flex flex-grow-1"
          :class="{
            'align-center': totalGames >= 0 || type != 'category',
            'my-3': $vuetify.breakpoint.mobile,
          }"
        >
          <!-- Back Button -->
          <v-btn large icon @click="goBack">
            <v-icon large>mdi-chevron-left</v-icon>
          </v-btn>

          <!-- Title Page -->
          <div
            class="d-flex"
            :class="{
              'flex-column': totalGames >= 0 && type != 'category',
            }"
          >
            <span
              :class="
                $vuetify.breakpoint.smAndDown ? 'text-h6' : 'text-h5 pl-2'
              "
            >
              {{ backButtonDescription }}
            </span>
            <!-- <small class="total-item-number" v-if="type === 'providers'">
              <span v-if="fetchingLobby === false">
                {{ `${showingItems.length} ${this.$t("newCasino.providers")}` }}
              </span>
              <span v-else>
                <v-skeleton-loader type="text" width="80" />
              </span>
            </small>
            <div class="total-item-number pt-1" v-else>
              <span v-if="totalGames >= 0 && type != 'category'">
                {{ `${totalGames} ${this.$t("newCasino.games")}` }}
              </span>
              <span v-else-if="fetchingLobby && type != 'category'">
                <v-skeleton-loader type="text" width="80" />
              </span>
            </div> -->
          </div>
        </div>

        <ToolbarFilters
          v-if="type === 'category' || type === 'favorites'"
          :providers="providers"
          :originalItems="originalItems"
        />
      </div>

      <div :class="$vuetify.breakpoint.xs && 'px-2'">
        <div
          :style="{
            display: 'grid',
            gridTemplateColumns: `repeat(${columnGrid}, 1fr)`,
            gap: $vuetify.breakpoint.xs ? '8px' : '16px',
          }"
          class="mt-6"
          name="slide"
          is="transition-group"
        >
          <div v-for="item in showingItems" :key="item.key" class="pt-0">
            <Item :key="item.key" :item="item" :type="type" />
          </div>
        </div>
      </div>

      <div
        v-if="showingItems.length === 0 && (fetchingLobby || indexedDbFetching)"
        class="d-flex justify-center pt-6"
      >
        <v-progress-circular
          :size="32"
          color="primary"
          indeterminate
        ></v-progress-circular>
      </div>

      <div
        v-else-if="indexedDbFetching === false && showingItems.length === 0"
        class="mt-4"
      >
        <v-alert type="info" dense text border="left">
          {{
            type === "favorites" ?
              $t("newCasino.noGamesFoundFavorite") :
              $t("newCasino.noGamesFound", {
                thisPronoun:
                  type === "provider"
                    ? this.$t("newCasino.thisMasculine")
                    : this.$t("newCasino.thisFeminine"),
                model:
                  type === "provider"
                    ? this.$t("newCasino.provider")
                    : this.$t("newCasino.category"),
                withFilters:
                  this.providersFilter.length > 0
                    ? this.$t("newCasino.withFilters")
                    : ".",
              })
          }}
        </v-alert>
      </div>
    </div>

    <div
      class="d-flex flex-column align-center justify-center mx-auto mt-10"
      v-if="type !== 'providers' && showingItems.length > 0"
      style="width: fit-content"
    >
      <v-progress-linear
        min="1"
        max="100"
        color="primary"
        :value="(showingItems.length / totalGames) * 100"
      ></v-progress-linear>

      <small style="font-weight: bold" class="my-4">
        {{
          $t("newCasino.showingGamesProgress", {
            current: showingItems.length,
            total: totalGames,
          })
        }}
      </small>

      <v-btn
        outlined
        v-show="itemsLeft.length > 0"
        small
        color="primary"
        @click="loadMore"
      >
        {{ $t("newCasino.loadMore") }}
      </v-btn>
    </div>
  </div>
</template>

<script>
import Item from "../item";
import ToolbarFilters from "../../components/ToolbarFilters.vue";
import { listGamesFavorites } from "@/util/casino/gameFavorite.js";

export default {
  props: ["providers", "games"],

  components: { Item, ToolbarFilters },

  data: () => ({
    dialog: false,
    bottomSheet: false,
    loading: false,
    viewingItem: {},
    showingItems: [],
    itemsLeft: [],
    originalItems: [],
  }),

  created() {
    this.fetchItems();
    this.setPageTitle();
  },

  computed: {
    alphabeticalOrder() {
      return this.$store.state.casinoFilters.alphabeticalOrder;
    },
    providersFilter() {
      return this.$store.state.casinoFilters.providers;
    },
    fetchingLobby() {
      return (
        (this.type === "providers" && this.showingItems.length === 0) ||
        this.$store.state.fetchingCasinoLobby
      );
    },
    indexedDbFetching() {
      return this.$store.state.indexedDbFetching;
    },
    type() {
      if (this.$route.params.providerId) {
        return "provider";
      } else if (this.$route.params.category) {
        return "category";
      } else if (
        this.$route.name === "casinoFavorites" ||
        this.$route.name === "casinoGameFavorites"
      ) {
        return "favorites";
      } else {
        return "providers";
      }
    },
    totalGames() {
      return this.showingItems.length + this.itemsLeft.length;
    },
    providerName() {
      if (this.$route.name !== "casinoProvider") {
        return "";
      }

      if (!Array.isArray(this.$store.state.casinoProviders)) {
        return;
      }

      const provider = this.$store.state.casinoProviders.find(
        (provider) => provider.id == this.$route.params.providerId
      );

      if (provider) {
        return provider.name;
      }

      return "";
    },
    categoryName() {
      return this.$route.params.category;
    },
    backButtonDescription() {
      const map = {
        providers: this.$t("newCasino.providers"),
        provider: this.providerName,
        category: this.$route.params.category,
        favorites: this.$t("favorites"),
      };

      return map[this.type];
    },
    columnGrid() {
      var boolProviders = this.type === "providers";
      switch (this.$vuetify.breakpoint.name) {
        case "xs": // < 600 px
          return boolProviders ? 2 : 3;
        case "sm": // 600 px > < 960 px
        case "md": // 960px > < 1264px*
        case "lg": // 1264px > < 1904px*
        case "xl": // > 1904px*
          return 6;
        default:
          return 6;
      }
    },
    gamesFavoritesUpdating() {
      return this.$store.state.gamesFavoritesUpdating;
    },
  },

  watch: {
    alphabeticalOrder(val) {
      if (this.type === "providers") {
        if (val === "A - Z") {
          this.showingItems = [...this.originalItems].sort((a, b) => {
            return a.name.localeCompare(b.name);
          });
        } else {
          this.showingItems = [...this.originalItems].sort((a, b) =>
            b.name.localeCompare(a.name)
          );
        }
      } else {
        this.filterAndOrder();
      }
    },
    providersFilter() {
      if (this.type === "category" || this.type === "favorites") {
        this.filterAndOrder();
      }
    },
    providers(val) {
      if (this.type === "providers" && this.showingItems.length === 0) {
        this.showingItems = val;
      }

      this.fetchItems();
    },
    games() {
      this.fetchItems();
    },
    "$route.params.category"() {
      this.fetchItems();
      this.setPageTitle();
    },
    "$route.params.providerId"() {
      this.fetchItems();
      this.setPageTitle();
    },
    gamesFavoritesUpdating(updating) {
      if (updating && this.type === "favorites") {
        this.fetchItems();
      }
    },
  },

  methods: {
    async fetchItems() {
      this.showingItems = [];
      this.itemsLeft = [];

      if (this.$route.params.providerId) {
        this.fetchProviderGames();
      } else if (this.$route.params.category) {
        this.fetchCategoryGames();
      } else if (this.type === "favorites") {
        this.fetchFavoritesGames();
      } else {
        this.showingItems = this.providers;
        this.originalItems = [...this.showingItems];
      }
    },
    fetchProviderGames() {
      if (this.indexedDbFetching) {
        return [];
      }

      if (!this.games || this.games.length === 0) {
        return [];
      }

      const uniqueGames = [];

      this.games.forEach((game) => {
        if (
          game.id_provider == this.$route.params.providerId &&
          !uniqueGames.find(({ game_id }) => game_id === game.game_id)
        ) {
          uniqueGames.push(game);
        }
      });

      this.itemsLeft = uniqueGames;

      this.loadMore();
    },
    fetchCategoryGames() {
      if (this.indexedDbFetching) {
        return [];
      }

      const uniqueGames = [];

      this.games.forEach((game) => {
        if (
          game.categories.includes(this.$route.params.category) &&
          !uniqueGames.find(({ game_id }) => game_id === game.game_id)
        ) {
          uniqueGames.push(game);
        }
      });

      this.itemsLeft = uniqueGames;

      this.loadMore();
    },
    fetchFavoritesGames() {
      if (this.indexedDbFetching) return [];

      const gamesFavorites = listGamesFavorites(this.$route.params.casinoType);

      if (gamesFavorites.length > 0) {
        this.showingItems = [];
        this.originalItems = [];
        this.itemsLeft = [];

        this.itemsLeft = gamesFavorites;

        this.loadMore();
      } else {
        this.showingItems = [];
        this.originalItems = [];
        this.itemsLeft = [];
      }
    },
    loadMore() {
      if (this.showingItems.length === 0) {
        this.originalItems = [...this.itemsLeft];
        this.filterAndOrder();
        return;
      }

      this.showingItems = [
        ...this.showingItems,
        ...this.itemsLeft.splice(0, 30),
      ];
    },
    goBack() {
      const previousType = localStorage.getItem("previousType");

      if (this.type === "category" && previousType === "category") {
        this.$router.go(-1);
      } else if (this.type === "category" && previousType !== "category") {
        this.$router.push({
          name: "casinoLobby",
        });
        return;
      }

      if (this.type === "provider" && previousType === "provider") {
        this.$router.go(-1);
      } else if (this.type === "provider" && previousType !== "provider") {
        this.$router.push({
          name: "casinoProviders",
        });
      } else if (this.type === "providers") {
        this.$router.push({
          name: "casinoLobby",
        });
        return;
      }

      if (this.type === "favorites") {
        this.$router.push({
          name: "casinoLobby",
        });
      }
    },
    setPageTitle() {
      if (this.type === "provider") {
        document.title = `${this.providerName} - ${this.$store.state.operators.operator_name}`;
      } else if (this.type === "category") {
        document.title = `${this.$route.params.category} - ${this.$store.state.operators.operator_name}`;
      } else if (this.type === "favorites") {
        document.title = `${this.$t("newCasino.gamesFavorites")} - ${this.$store.state.operators.operator_name}`;
      } else {
        document.title = `${this.$t("newCasino.pageTitle.providers")} - ${
          this.$store.state.operators.operator_name
        }`;
      }
    },
    filterAndOrder() {
      this.showingItems = [];
      this.itemsLeft = [];
      let filteredItems = [];

      // Alphabetical order
      if (this.alphabeticalOrder === "A - Z") {
        filteredItems = [...this.originalItems].sort((a, b) =>
          a.title_game.localeCompare(b.title_game)
        );
      } else {
        filteredItems = [...this.originalItems].sort((a, b) =>
          b.title_game.localeCompare(a.title_game)
        );
      }

      // Provider filter
      if (
        this.providersFilter.length > 0 &&
        !this.$route.path.includes("providers")
      ) {
        const filteredItemsProvidersSelected = filteredItems.filter((game) => {
          return this.providersFilter.includes(game.id_provider);
        });

        if (filteredItemsProvidersSelected.length === 0) {
          // Resetando provedores selecionados em categorias anteriores para não
          // filtrar jogos de provedores inexistentes na categoria atual
          this.$store.commit("setCasinoProvidersFilter", []);
        } else {
          filteredItems = filteredItemsProvidersSelected;
        }
      }

      this.itemsLeft = filteredItems;
      this.showingItems = [
        ...this.showingItems,
        ...this.itemsLeft.splice(0, 30),
      ];

      // if (this.showingItems.length === 0) {
      //   this.$router.push({
      //     name: "casinoLobby",
      //   });
      // }
    },
  },
};
</script>
<style>
.fade-enter-active {
  transition: opacity 0.2s;
}

.fade-leave-active {
  transition: opacity 0s;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

.five-item-row {
  width: 20% !important;
  max-width: 20% !important;
  flex-basis: 20% !important;
}

.slide-enter {
  opacity: 0;
}

.slide-move {
  transition: transform 1s;
}

.slide-enter-active {
  animation: slide-in 0.3s ease-out forwards;
  transition: opacity 0.3s;
}

.slide-leave-active {
  position: absolute;
  width: 100%;
  animation: slide-out 0.3s ease-out forwards;
  transition: none;
  opacity: 0;
}

@keyframes slide-in {
  from {
    transform: translateY(-20px);
  }
  to {
    transform: translateY(0px);
  }
}

@keyframes slide-out {
  from {
    transform: translateX(0px);
  }
  to {
    transform: translateX(350px);
  }
}
</style>
